import React from "react";
import {
  Route,
  Switch,
  useRouteMatch,
  NavLink as Links,
} from "react-router-dom";
import AccountHeadDetails from "./AccountHeadDetails";
import Error404 from "../../../Components/Error404";
import viewAccountHead from "./viewAccountHead";
import AddAccount from "./AddAccount";
export default function AccountHead(props) {
  const { url } = useRouteMatch();
  return (
    <div className="col-md-12 col-xl-12">
      <div className="card">
        <header className="header no-border">
          <div className="header-info">
            <div className="left">
              <h2 className="header-title">
                <strong>Account Head</strong>
                <small className="subtitle">
                  Here you can edit,delete,view Account Heads.
                </small>
              </h2>
            </div>
            <div className="right gap-items-2">
              {props.location.pathname !== url ? (
                <Links
                  className="btn btn-mute btn-square btn-round"
                  activeClassName="active"
                  to={url}
                >
                  <span className="material-icons-outlined">arrow_back</span>
                </Links>
              ) : (
                <Links
                  className="btn btn-primary  btn-float btn-round"
                  activeClassName="active"
                  to={`${url}/Add`}
                >
                  <span className="material-icons-outlined">add</span>
                </Links>
              )}
            </div>
          </div>
          <div className="header-action"></div>
        </header>
        <div className="card-body">
          <Switch>
            <Route path={url} exact component={AccountHeadDetails} />
            <Route path={`${url}/Add`} component={AddAccount} />
            <Route path={`${url}/View/:id`} component={viewAccountHead} />
            <Route path="*">
              <Error404 />
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
}
